import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SelectedPassengerComponent from '@websky/core/src/SelectedPassenger/components/SelectedPassenger';
import { hideText } from '@websky/core/src/Passenger/utils';
import { useTheme } from '@websky/core/src/theme';
import { decapitalizeFirstLetter } from '@websky/core/src/utils';
import { TravellerFieldEnum } from '@websky/graphql';
const SelectedPassenger = props => {
    const { passenger: passengerValues } = props;
    const css = useTheme('SelectedPassenger').SelectedPassenger;
    const { t } = useTranslation('SelectedPassenger');
    const { passenger, nationalities } = useMemo(() => {
        const passenger = {};
        const nationalities = new Map();
        passengerValues.values.forEach(value => {
            passenger[decapitalizeFirstLetter(value.type)] = value.value;
            if (value.type === TravellerFieldEnum.Nationality) {
                value.validationRules[0].options.forEach(nationality => {
                    nationalities.set(nationality.value, nationality.label);
                });
            }
        });
        return { passenger, nationalities };
    }, [passengerValues]);
    const renderInfoItems = useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css.passengerInfo__item },
            React.createElement("div", { className: css.passengerInfo__field },
                React.createElement("span", null,
                    passenger.birthDate,
                    ","),
                React.createElement("span", null, passenger.gender === 'M' ? t('Male') : t('Female')))),
        React.createElement("div", { className: css.passengerInfo__item },
            React.createElement("div", { className: css.passengerInfo__field },
                React.createElement("span", null,
                    t('Citizenship'),
                    ":"),
                React.createElement("span", null,
                    nationalities.get(passenger.nationality),
                    ","),
                " ",
                React.createElement("span", null,
                    t(passenger.docType),
                    ":"),
                ' ',
                React.createElement("span", null,
                    passenger.docNumber ? hideText(passenger.docNumber) : '-',
                    ","),
                ' ',
                React.createElement("span", null,
                    t('Expiry date'),
                    ":"),
                " ",
                React.createElement("span", null, passenger.docExpiryDate))))), []);
    return React.createElement(SelectedPassengerComponent, Object.assign({}, props, { infoItems: renderInfoItems }));
};
export default SelectedPassenger;
